import React from 'react';
import moment from 'moment';
// @material-ui/core components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import Typography from '@material-ui/core/Typography';
// @material-ui/icons
// core components
import GridContainer from 'components/Grid/GridContainer.jsx';
import GridItem from 'components/Grid/GridItem.jsx';
import CustomInput from 'components/CustomInput/CustomInput.jsx';
import localization from '../../i18n/localization';

const Payment = ({ order }) => {
  const payment = order && order.payment ? order.payment : null;
  const voucher = order && order.voucher ? order.voucher : null;
  const hasRefund = payment ? !!payment.refundedAmount : null;

  return (
    <div>
      <GridContainer>
        <GridItem xs={12} sm={12} md={hasRefund ? 3 : 4} lg={hasRefund ? 3 : 4}>
          <CustomInput
            labelText={'\u00dcberwiesen (CHF)'}
            inputProps={{
              value: payment
                ? (payment.initialAmount / 100).toFixed(2)
                : (order ? order.price / 100 : 0).toFixed(2),
              disabled: true,
            }}
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
        {payment && payment.refundedAmount ? (
          <React.Fragment>
            <GridItem xs={12} sm={12} md={3} lg={3}>
              <CustomInput
                labelText={'R\u00fcckerstattet (CHF)'}
                inputProps={{
                  value: (payment.refundedAmount / 100).toFixed(2),
                  disabled: true,
                }}
                formControlProps={{
                  fullWidth: true,
                }}
              />
            </GridItem>
          </React.Fragment>
        ) : null}
        <GridItem xs={12} sm={12} md={hasRefund ? 3 : 4} lg={hasRefund ? 3 : 4}>
          <CustomInput
            labelText={'Saldo (CHF)'}
            inputProps={{
              value: payment
                ? (
                    (payment.initialAmount - payment.refundedAmount) /
                    100
                  ).toFixed(2)
                : order
                  ? order.price
                  : 0,
              disabled: true,
            }}
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
        <GridItem xs={12} sm={12} md={hasRefund ? 3 : 4} lg={hasRefund ? 3 : 4}>
          <CustomInput
            labelText={'Verk\u00e4ufer'}
            inputProps={{
              value: payment ? localization.de[payment.merchant] : '',
              disabled: true,
            }}
            formControlProps={{
              fullWidth: true,
            }}
          />
        </GridItem>
      </GridContainer>
      {payment ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div style={{ marginTop: 20 }}>
              <Typography variant="inherit" color="textSecondary" gutterBottom>
                Credit Card
              </Typography>
            </div>
          </GridItem>
          {payment.cardType ? (
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <CustomInput
                labelText="Kredit Karte"
                inputProps={{
                  value: payment.cardType,
                  disabled: true,
                }}
                formControlProps={{
                  fullWidth: true,
                }}
              />
            </GridItem>
          ) : null}
          {payment.cardNumber ? (
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <CustomInput
                labelText="Kreditkarten Nummer"
                inputProps={{
                  value: payment.cardNumber,
                  disabled: true,
                }}
                formControlProps={{
                  fullWidth: true,
                }}
              />
            </GridItem>
          ) : null}
        </GridContainer>
      ) : null}
      {voucher ? (
        <GridContainer>
          <GridItem xs={12} sm={12} md={12} lg={12}>
            <div style={{ marginTop: 20 }}>
              <Typography variant="inherit" color="textSecondary" gutterBottom>
                Voucher
              </Typography>
            </div>
          </GridItem>
          {voucher.code ? (
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <CustomInput
                labelText="Voucher Code"
                inputProps={{
                  value: voucher.code,
                  disabled: true,
                }}
                formControlProps={{
                  fullWidth: true,
                }}
              />
            </GridItem>
          ) : null}
          {voucher.usedAmount ? (
            <GridItem xs={12} sm={12} md={6} lg={6}>
              <CustomInput
                labelText="Voucher Amount"
                inputProps={{
                  value: (voucher.usedAmount / 100).toFixed(2),
                  disabled: true,
                }}
                formControlProps={{
                  fullWidth: true,
                }}
              />
            </GridItem>
          ) : null}
        </GridContainer>
      ) : null}
      {voucher || (payment && payment.transactions.length) ? (
        <div style={{ marginTop: 10 }}>
          <Typography variant="subheading" color="textSecondary" gutterBottom>
            Transaktionen
          </Typography>
          <List dense>
            {payment &&
              payment.transactions
                .sort((a, b) => {
                  if (a.createdAt > b.createdAt) {
                    return 1;
                  }
                  if (b.createdAt > a.createdAt) {
                    return -1;
                  }
                  return 0;
                })
                .map((transaction, index) => (
                  <ListItem
                    key={index}
                    style={{
                      backgroundColor:
                        index % 2 === 0 ? '#eeeeee61' : 'inherit',
                      display: 'flex',
                    }}
                  >
                    <div style={{ flex: 1 }}>
                      <Typography color="textPrimary">
                        {localization.de[transaction.type]}
                      </Typography>
                      <Typography color="textSecondary">
                        {moment(transaction.createdAt).format(
                          'DD.MM.YYYY HH:mm'
                        )}{' '}
                        - {transaction.issuer}
                      </Typography>
                      <Typography color="textSecondary">
                        ID: {transaction.paymentTransactionId}
                      </Typography>
                    </div>
                    <Typography color="textSecondary">
                      {(transaction.amount / 100).toFixed(2) + ' CHF'}
                    </Typography>
                  </ListItem>
                ))}
            {voucher ? (
              <ListItem
                style={{
                  backgroundColor:
                    payment && payment.transactions.length % 2 === 0
                      ? 'inherit'
                      : '#eeeeee61',
                  display: 'flex',
                }}
              >
                <div style={{ flex: 1 }}>
                  <Typography color="textPrimary">
                    {localization.de['voucherPayment']}
                  </Typography>
                  <Typography color="textSecondary">
                    {moment(voucher.createdAt).format('DD.MM.YYYY HH:mm')} -{' '}
                    {order.user.email}
                  </Typography>
                  <Typography color="textSecondary">
                    Redemption ID: {voucher.redemptionId}
                  </Typography>
                </div>
                <Typography color="textSecondary">
                  {(voucher.usedAmount / 100).toFixed(2) + ' CHF'}
                </Typography>
              </ListItem>
            ) : null}
          </List>
        </div>
      ) : null}
    </div>
  );
};

export default Payment;



// WEBPACK FOOTER //
// ./src/views/payment/Payment.jsx